import axios from 'axios';
import toast from 'react-hot-toast';

/**
 * @param {string} entityName - اسم الشاشة (ex: 'workorders')
 * @param {object} filters - الفلاتر الحالية
 * @param {object} columnsMap - قاموس الترجمة للأعمدة {"db_col": "Translated Name"}
 * @param {function} t - دالة الترجمة (ممررة من الشاشة)
 */
export const exportToExcel = async (entityName, filters, columnsMap, t) => {
    // 🎯 استخدام الترجمة مع توفير نص افتراضي (Fallback) باللغة الإنجليزية
    const loadId = toast.loading(t('export.loading', 'Extracting data...')); 
    
    try {
        const token = localStorage.getItem('token');
        
        const response = await axios.post(`/api/export/${entityName}`, {
            filters: filters,
            columns: columnsMap
        }, {
            headers: { 'Authorization': `Bearer ${token}` },
            responseType: 'blob' 
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        
        const disposition = response.headers['content-disposition'];
        let filename = `${entityName}_export.xlsx`;
        if (disposition && disposition.indexOf('filename=') !== -1) {
            filename = disposition.split('filename=')[1].replace(/['"]/g, '');
        }

        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);

        toast.success(t('export.success', 'Exported successfully!'), { id: loadId });
    } catch (error) {
        console.error("Export Error:", error);
        toast.error(t('export.error', 'Error exporting data.'), { id: loadId });
    }
};